export const InboxesListsViewName = 'inboxesListsViewNameComponent';
